export default __webpack_public_path__ + "static/media/p16.c1000d4f.jpg";